// extracted by mini-css-extract-plugin
module.exports = {"YoutubeEmbed":"bak_a"};